import React from 'react';
import Axios from 'axios';
import { API_HOST } from './../../constants/server.constant';
import $ from 'jquery'
import './Region.css'

class Region extends React.Component{

    constructor(props){
        super(props)

        this.state={
            regionList : [],
            regionListFilter : [],
            regionName : "",
            regionid:""
        }

        this.getRegionDropdown = this.getRegionDropdown.bind(this)
        this.filterDropDown = this.filterDropDown.bind(this)
        this.getSelectedRegion = this.getSelectedRegion.bind(this)
    }

    componentDidMount(){

        const requestOptions = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                "Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
            }
        }
        
        Axios.get(API_HOST+"/regions/getall",requestOptions,)
        .then(resp=>{
            let region = []
            for(let i=0;i<resp.data.length;i++){

                let reg = resp.data[i]
               
                let obj = {
                    id : reg.region_id,
                    name : reg.name,
                    countryName : reg.country_name
                }
               
                region.push(obj)
            }
            this.setState({
                regionList : region,
                regionListFilter : region
            })
        })
        .catch(error=>{
            this.setState({
                regionList : []
            })
        })

    }

    getRegionDropdown = ()=>{
        $(".regionSelect_options").addClass("active")
    }
    filterDropDown = (event)=>{
        $(".regionSelect_options").addClass("active")
        
        let name = event.target.name
        let val = event.target.value

        this.setState({
            regionListFilter : this.state.regionList.filter(item =>item.name.includes(val)),
            regionName : val
        })
        
    }

    getSelectedRegion=(event,id,region,countryName)=>{
        $(".regionSelect_options").removeClass("active")
        this.setState({
            regionName:region,
            regionid : id
        })

    }

    render(){

        return(
           
            <div className="region_select_container">
                <div className="slectBox">
                    <div className="search_inp_box optUnselect">
                        <input type="text" name="regionName" value={this.state.regionName} onClick = {this.getRegionDropdown}  placeholder="Select a Region" onChange = {this.filterDropDown}></input>
                        <input type="hidden" name="regionid" value={this.state.regionid}></input>
                    </div>
                    <ul>
                      <li className="selected_elem"><span className={"country_flag "+this.state.countryName}></span>{this.state.regionName}({this.state.id})</li>
                    </ul>
                    <span className="dropArrow"> <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                        <title>drop-down</title>
                        <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                        </svg> 
                    </span>
                </div>
                <div className="regionSelect_options">
                    {this.state.regionListFilter.length <=0?
                        <ul className="noSearchRes" style={{display:this.state.regionListFilter.length <=0?"none":""}}>
                        <li>No Search Found</li>
                        </ul>
                        :
                        <ul>
                            {this.state.regionListFilter.map((region,i)=>
                                <li className="option_elem" key = {i} onClick = {(e)=>this.getSelectedRegion(e,region.id,region.name,region.countryName)}><span className={'country_flag '+region.countryName} ></span>{region.name}({region.id})
                                </li>
                            )}
                            
                        </ul>
                    }
                </div>
            </div>
           
        )
    }
    

}

export default Region;

